import { noop } from 'lodash/fp';
import { DataTestId } from '@mews-commander/enums';
import { PaymentCard } from '@mews-commander/types';
import { DropdownItem, DropdownItemProps } from '@optimus-web/core';
import { createCardLabel } from '@mews-commander/legacy-entities/src/ducks/paymentCards';
import PaymentCardIcon from '../../../../../../components/commander-ui/PaymentCardIcon';
import { SecondaryText } from './SecondaryText';

interface PaymentCardOptionProps {
    handlePaymentCardClick: (paymentCardId: string) => void;
    paymentCard: PaymentCard;
    enterpriseId: string;
    shouldShowSurcharge: boolean;
    onClick(): void;
}

export const PaymentCardOption = ({
    shouldShowSurcharge,
    enterpriseId,
    handlePaymentCardClick,
    paymentCard,
    onClick = noop,
}: PaymentCardOptionProps) => {
    const handleClick: DropdownItemProps['onClick'] = (e, value) => {
        if (typeof value === 'string') {
            handlePaymentCardClick(value);
        }
        onClick();
    };

    return (
        <DropdownItem
            value={paymentCard.id}
            onClick={handleClick}
            leftDetail={<PaymentCardIcon type={paymentCard.type} width={24} />}
            label={createCardLabel(paymentCard)}
            description={
                shouldShowSurcharge ? (
                    <SecondaryText enterpriseId={enterpriseId} paymentCardType={paymentCard.type} />
                ) : null
            }
            data-test-id={DataTestId.BillingChargeCreditCardDropdownOption}
        />
    );
};
